import * as QrWaiter from "./QrWaiter";
import { getMobileAppType } from "../utils/getMobileAppType";
/**
 * Interpret `data-visible-in` attribute on menu elements, i.e. hide elements not visible in current MenuConsumer.
 */
export function applyMenuVisibleIn() {
    const menuConsumer = QrWaiter.isQrWaiterOrder()
        ? "QrWaiter"
        : getMobileAppType() !== null
            ? "MobileApp"
            : "Site";
    // TODO: remove Site fallback once MobileApp has been added to menus
    // MobileApp falls back to Site for elements that predate MobileApp (e.g. menu sections/products)
    const acceptedConsumers = menuConsumer === "MobileApp" ? ["MobileApp", "Site"] : [menuConsumer];
    for (const elem of document.querySelectorAll("[data-visible-in]")) {
        const visibleIn = elem
            .getAttribute("data-visible-in")
            .split(",");
        if (!acceptedConsumers.some((c) => visibleIn.includes(c))) {
            elem.style.display = "none";
            elem.classList.remove("js-group-item");
        }
    }
}
